export default __webpack_public_path__ + "img/how-to-use-slide02.48cb6913.webp";